import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { DadosContatoAba8DTO } from '../../model/DadosContatoAba8DTO';
import { DadosContatoAba8 } from '../../service/dados-contato-aba8/dados-contato-aba8.service';

import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MaskUtil } from "../../utils/mask-util";

@Component({
  selector: 'app-recadastramento-aba8',
  templateUrl: './recadastramento-aba8.component.html',
  styleUrls: ['./recadastramento-aba8.component.sass']
})
export class RecadastramentoAba8Component implements OnInit {

  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  form: FormGroup;
  user: DadosPessoaisAba1Response = null;
  arquivoEnviadoEstrangeiro: boolean = false;
  arquivoSelecionadoEstrangeiro: File;

  dataChegadaBrasil: Date;
  classificacaoCondicacaoIngresso: number;
  casadoComBrasileiro: string;
  filhosBrasileiros: string;

  existDiffDataChegadaBrasil: boolean = false;

  isLoading: boolean = true;
  isInfoImportantVisible: boolean = true;
  dadosContato: DadosContatoAba8DTO;
  isLoadingSpinner: boolean = false
  email: string;
  numeTelResid: string;
  numeTelResid2: string;
  numeTelCelular: string;
  numeCelular: string;


  constructor(
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private dadosContatoAba8: DadosContatoAba8) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));

    this.form = this.formBuilder.group({
      numeDddTel: [''],
      numeTelResid: [''],
      numeDddCelular: [''],
      numeCelular: [''],
      numeDddTelResid2: [''],
      numeTelResid2: [''],
      email: ['', [Validators.email]],
    });
    this.aplicarMascaraTelefoneNoCampo('numeTelResid');
    this.aplicarMascaraTelefoneNoCampo('numeCelular');
    this.aplicarMascaraTelefoneNoCampo('numeTelResid2');
  }

  ngOnInit(): void {
    this.processarDadosContato()
    this.atualizarValidacaoDddTelResid();
    this.atualizarValidacaoTelCelular();
    this.atualizarValidacaoNumeTelResid2();
    this.form.get('numeDddTel').valueChanges.subscribe(() => {
      if (!this.updatingValidators) {
        this.updatingValidators = true;
        this.atualizarValidacaoDddTelResid();
        this.updatingValidators = false;
      }
    });

    this.form.get('numeTelResid').valueChanges.subscribe(() => {
      if (!this.updatingValidators) {
        this.updatingValidators = true;
        this.atualizarValidacaoDddTel();
        this.updatingValidators = false;
      }
    });
    this.form.get('numeDddCelular').valueChanges.subscribe(() => {
      if (!this.updatingValidators) {
        this.updatingValidators = true;
        this.atualizarValidacaoTelCelular();
        this.updatingValidators = false;
      }
    });

    this.form.get('numeCelular').valueChanges.subscribe(() => {
      if (!this.updatingValidators) {
        this.updatingValidators = true;
        this.atualizarValidacaoDddCelular();
        this.updatingValidators = false;
      }
    });
    this.form.get('numeTelResid2').valueChanges.subscribe(() => {
      if (!this.updatingValidators) { // Check if validators are being updated
        this.updatingValidators = true; // Set the flag to true to prevent circular calls
        this.atualizarValidacaoDddTelCelular();
        this.updatingValidators = false; // Reset the flag after updating validators
      }
    });
    this.form.get('numeDddTelResid2').valueChanges.subscribe(() => {
      if (!this.updatingValidators) { // Check if validators are being updated
        this.updatingValidators = true; // Set the flag to true to prevent circular calls
        this.atualizarValidacaoNumeTelResid2();
        this.updatingValidators = false; // Reset the flag after updating validators
      }
    });
  }

  private updatingValidators = false;


  atualizarValidacaoDddTelResid() {
    const numeDddTel = this.form.get('numeDddTel');
    const numeTelResid = this.form.get('numeTelResid');
    if (numeDddTel && numeDddTel.value != '' && numeDddTel.value != null ) {
      //.setValidators([Validators.required]);
      numeTelResid.setValidators([Validators.minLength(8), Validators.required]);
    } else {
      numeDddTel.clearValidators();
      numeTelResid.clearValidators();
    }

    numeDddTel.updateValueAndValidity();
    numeTelResid.updateValueAndValidity();
  }

  atualizarValidacaoDddTelCelular() {
    const numeTelCelular = this.form.get('numeTelResid2');
    const numeDddTelCelular = this.form.get('numeDddTelResid2');

    if (numeTelCelular && numeTelCelular.value != '') {
      numeDddTelCelular.setValidators([Validators.required, Validators.minLength(2)]);
      numeTelCelular.setValidators([Validators.minLength(8)]);
    } else {
      numeDddTelCelular.clearValidators();
    }
    numeDddTelCelular.updateValueAndValidity();
    numeTelCelular.updateValueAndValidity(); // Update the other control as well
  }

  atualizarValidacaoNumeTelResid2() {
    const numeTelCelular = this.form.get('numeTelResid2');
    const numeDddTelCelular = this.form.get('numeDddTelResid2');
    if (numeDddTelCelular && numeDddTelCelular.value != '' && numeDddTelCelular.value != null) {
      // numeDddTelCelular.setValidators([Validators.required, Validators.minLength(2)]);
      numeTelCelular.setValidators([Validators.required, Validators.minLength(8)]);
    } else {
      numeTelCelular.clearValidators();
    }
    numeDddTelCelular.updateValueAndValidity();
    numeTelCelular.updateValueAndValidity(); // Update the other control as well
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mostrarAlerta) {
      this.isInfoImportantVisible = true
    }
  }

  aplicarMascaraTelefoneNoCampo(campo: string) {
    const control = this.form.get(campo);
    const initialValue = control.value;
    const formattedInitialValue = this.aplicarMascaraTelefone(initialValue);
    control.setValue(formattedInitialValue, { emitEvent: false });

    control.valueChanges.subscribe(value => {
      const formattedValue = this.aplicarMascaraTelefone(value);
      control.setValue(formattedValue, { emitEvent: false });
    });
  }

  aplicarMascaraTelefone(value: string): string {
    if (value) {
      const numeroApenasDigitos = value.replace(/\D/g, '');

      let foneFormatado = '';

      if (numeroApenasDigitos.length === 9) {
        foneFormatado = numeroApenasDigitos.replace(/(\d{5})(\d{4})/, '$1-$2');
      } else if (numeroApenasDigitos.length === 8) {
        foneFormatado = numeroApenasDigitos.replace(/(\d{4})(\d{4})/, '$1-$2');
      } else {
        foneFormatado = numeroApenasDigitos;
      }

      return foneFormatado;
    }

    return '';
  }

  atualizarValidacaoDddTel() {
    const numeTelResid = this.form.get('numeTelResid');
    const numeDddTel = this.form.get('numeDddTel');

    if (numeTelResid && numeTelResid.value != '' && numeTelResid.value != null) {
      numeDddTel.setValidators([Validators.required, Validators.minLength(2)]);
      numeTelResid.setValidators([Validators.minLength(8), Validators.required]);
    } else {
      numeDddTel.clearValidators();
      numeTelResid.clearValidators();
    }

    numeDddTel.updateValueAndValidity();
    numeTelResid.updateValueAndValidity();
  }

  atualizarValidacaoTelCelular() {
    const numeTelCelular = this.form.get('numeCelular');
    const numeDddCelular = this.form.get('numeDddCelular');

    if (numeDddCelular && numeDddCelular.value != '' && numeDddCelular.value != null) {
      //numeDddCelular.setValidators([Validators.required, Validators.minLength(2)]);
      numeTelCelular.setValidators([Validators.minLength(8), Validators.required]);
    } else {
      //numeDddCelular.clearValidators();
      numeTelCelular.clearValidators();
    }

    numeDddCelular.updateValueAndValidity();
    numeTelCelular.updateValueAndValidity();
  }

  atualizarValidacaoDddCelular() {
    const numeTelCelular = this.form.get('numeCelular');
    const numeDddCelular = this.form.get('numeDddCelular');

    if (numeTelCelular && numeTelCelular.value) {
      numeDddCelular.setValidators([Validators.required, Validators.minLength(2)]);
      numeTelCelular.setValidators([Validators.minLength(8), Validators.required]);
    } else {
      numeDddCelular.clearValidators();
      numeTelCelular.clearValidators();
    }

    numeDddCelular.updateValueAndValidity();
    numeTelCelular.updateValueAndValidity();
  }
  apenasNumeros(event: KeyboardEvent) {
    const key = event.key;

    if (isNaN(Number(key)) && key !== 'Backspace') {
      event.preventDefault();
    }
  }


  private processarDadosContato(): void {

    this.isLoadingSpinner = true;
    const contato$: Observable<DadosContatoAba8DTO> = this.obterDadosContatos();
    forkJoin([contato$])
      .pipe(finalize(() => this.isLoadingSpinner = false))
      .subscribe(
        ([contato]) => {
          // Manipular os dados do endereço e UFs aqui
          //this.buscarTipoLogradouro()
          //this.buscarMunicipio();
          this.atualizarFormulario(contato);

        },
        (error) => {
          //this.mostrarMensagem('Ocorreu um erro ao carregar os dados. Por favor, tente novamente.');
        }
      );
  }
  private obterDadosContatos(): Observable<DadosContatoAba8DTO> {
    // Realize o GET novamente aqui
    return this.dadosContatoAba8.getDadosContato()
  }


  private atualizarFormulario(contato: DadosContatoAba8DTO): void {
    this.form.patchValue({
      numeDddTel: contato.numeDddTel,
      numeTelResid: contato.numeTelResid,
      numeCelular: contato.numeCelular,
      numeDddCelular: contato.numeDddCelular,
      numeDddTelResid2: contato.numeDddTelResid2,
      numeTelResid2: contato.numeTelResid2,
      email: contato.email,
    });
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  checkTemPeloMenosUmTelefone() {
    if (this.form.value.numeTelResid != '' && this.form.value.numeTelResid != null) {
      return true
    }
    else if (this.form.value.numeCelular != '' && this.form.value.numeCelular != null) {
      return true
    }
    else if (this.form.value.numeTelResid2 != '' && this.form.value.numeTelResid2 != null) {
      return true
    } else {
      return false
    }
  }
  removeMascaraTelefone(telefone: string): string {
    // Remova todos os caracteres que não são dígitos
    return telefone.replace(/\D/g, '');
  }

  atualizarContato() {
    if (this.checkTemPeloMenosUmTelefone()) {
      if (this.form.valid) {
        const formValueCopy = { ...this.form.value };

        // Remova a máscara apenas dos campos de telefone na cópia
        if (formValueCopy.numeTelResid) {
          formValueCopy.numeTelResid = formValueCopy.numeTelResid.replace(/\D/g, '');
        }
        if (formValueCopy.numeCelular) {
          formValueCopy.numeCelular = formValueCopy.numeCelular.replace(/\D/g, '');
        }
        if (formValueCopy.numeTelResid2) {
          formValueCopy.numeTelResid2 = formValueCopy.numeTelResid2.replace(/\D/g, '');
        }

        // Chame o método de atualização de dados e trate a resposta
        this.dadosContatoAba8.atualizarDadosContato(formValueCopy).subscribe(
          (response) => {
            this.toasterService.success('Dados atualizados com sucesso');
            this.dadosSalvos.emit();
            this.formularioSalvo.emit();
          },
          (error) => {
            console.error('Erro ao atualizar os dados', error);
          }
        );
      } else {
        const numeDddTel = this.form.get('numeDddTel');
        const numeDddCelular = this.form.get('numeDddCelular');
        const numeDddTelResid2 = this.form.get('numeDddTelResid2');


        if (numeDddTel.value && numeDddTel.value.length < 2 || numeDddCelular.value && numeDddCelular.value.length < 2 || numeDddTelResid2.value && numeDddTelResid2.value.length < 2) {
          this.toasterService.warning('Atenção: O campo DDD deve ter 2 caracteres.');
        }
      }
    }
    else {
      this.toasterService.warning('Atenção: É necessário ao menos um telefone preenchido');

    }
  }


  avancaParaProximoTab() {
    this.dadosSalvos.emit()

  }
  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

  validarCampo(event: any): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (!MaskUtil.validar_email(value)) {
      input.value = value.replace(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i, '');
    }
  }

}
